import  * as types from '../mutationTypes'

export default{
    [types.SET_ALERT](state, body){
       state.pop_ups = body
        
    },

    // [types.SET_VISIBILITY_GET_DATA](state, visibility){
    //     // state.get_data.isVisible = visibility
    // }
}